import { HostCardNumbersModel } from '@w3lcome/types';
import api from './base';
import { GetListType } from './types/GetListType';

class HostCardNumbersApi {
  private hostCardNumberUrl = '/host-card-numbers';

  public findByHostId = async (hostId: string) => {
    const { data } = await api.get<GetListType<HostCardNumbersModel>>(this.hostCardNumberUrl, {
      params: { hostId },
    });

    return data;
  };
}

export default new HostCardNumbersApi();
